import classNames from 'classnames';
import React from 'react';
import { InfoTooltip } from '../InfoTooltip';
import { WarningTooltip } from '../WarningTooltip';
import { Icon } from '../Icon';

interface PropTypes {
  fieldName?: string;
  isRequired?: boolean;
  hideRequireIndicator?: boolean;
  classNames?: string;
  fontSize?: string;
  maximumCharacters?: number;
  minimumCharacters?: number;
  wrapText?: boolean;
  tooltipText?: string;
  tooltipVariant?: 'info' | 'warning';
  // When true and tooltipText is not provided, render an invisible
  // icon-sized placeholder so the header height stays consistent across
  // states where the tooltip toggles on/off.
  tooltipPlaceholder?: boolean;
}

function LimitCharsSpan(props: { text: string }) {
  return (
    <span className='text-dark-200 text-nowrap fs-6 ms-auto'>{props.text}</span>
  );
}

export function FormFieldHeader(props: PropTypes) {
  return (
    <div
      className={classNames(
        'd-flex text-start mb-2 align-items-center',
        props.classNames,
      )}
    >
      {props.fieldName != null && (
        <label
          className={classNames(
            'fw-semibold',
            props.fontSize || 'fs-5',
            !props.wrapText && 'text-nowrap',
          )}
        >
          {props.fieldName}
        </label>
      )}
      {props.isRequired && !props.hideRequireIndicator && (
        <span
          className={classNames(
            props.fontSize,
            'd-inline text-danger fs-4 ps-1 mt-0',
          )}
        >
          *
        </span>
      )}
      {props.tooltipText && props.tooltipVariant === 'warning' && (
        <WarningTooltip className={'ms-2'}>{props.tooltipText}</WarningTooltip>
      )}
      {props.tooltipText && props.tooltipVariant !== 'warning' && (
        <InfoTooltip className={'ms-2'}>{props.tooltipText}</InfoTooltip>
      )}
      {!props.tooltipText && props.tooltipPlaceholder && (
        <span aria-hidden='true'>
          <Icon name='bi-info-circle' className='ms-2 invisible' />
        </span>
      )}
      {props.maximumCharacters && (
        <LimitCharsSpan
          text={`Maximum ${props.maximumCharacters} characters`}
        />
      )}
      {props.minimumCharacters && (
        <LimitCharsSpan text={`(${props.minimumCharacters} chars min.)`} />
      )}
    </div>
  );
}
